<template>
    <div 
        :class="{
            'global-nav font-weight-medium text-none': !isAlternativeMode,
            'font-weight-bold': isAlternativeMode
        }"
    >
        {{ title }}
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: "TitleFilter",
        props: {
            filterType: {
                type: String,
                required: true,
            }
        },
        computed: {
            ...mapGetters([
                'isAlternativeMode'
            ]),
            title() {
                return this.$t(`sidebar.filters.${this.$props.filterType}`);
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/filters/TitleFilter.vue